import { Component, OnInit } from '@angular/core';
import { CatalogosService } from '../../../services/catalogos.service';
import { TiposVeterinarios } from 'src/app/models/tipo-veterinarios.model';

@Component({
  templateUrl: './lista-veterinarios.component.html',
  styleUrls: ['./lista-veterinarios.component.css'],
})

export class Veterinarios implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Veterinarios',
      routerLink: '/veterinarios',
    },
  ];

  tipos: TiposVeterinarios[];
  loading = false;

  constructor(private catalogosService: CatalogosService) {}

  /*ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getDatosMercado().subscribe((tipos) => {
      this.loading = false;
      this.tipos = tipos;
    });
  }*/
  ngOnInit():void {
    this.loading = true;
    this.catalogosService.getTiposVeterinarios().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        const descripcion = p.descripcion.toString();
        array.push(p);
      });
      this.tipos = array;
    });
  }
}
